export default (i18n) => {
  return {
    ready_to_dispense: i18n.t("NamespaceDrugsEditor:Ready to transfer from the manufacturer"),
    in_transit_manufacturer_depot:
      i18n.t("NamespaceDrugsEditor:In transit to the depot"),
    received_by_depot: i18n.t("NamespaceDrugsEditor:Received by the depot"),
    in_transit_depot_pharmacy:
      i18n.t("NamespaceDrugsEditor:In transit to the pharmacy"),
    received_by_pharmacy: i18n.t("NamespaceDrugsEditor:Received by pharmacy"),
    quarantined: i18n.t("NamespaceDrugsEditor:Quarantined - Automatically"),
    reviewed_by_pharmacy_manufacturer: i18n.t("NamespaceDrugsEditor:Reviewed at the pharmacy"), // Reviewed -
    quarantined_by_pharmacy: i18n.t("NamespaceDrugsEditor:Quarantined - at pharmacy"),
    in_transit_pharmacy_fridge: i18n.t("NamespaceDrugsEditor:In transit to the fridge"),
    received_by_fridge: i18n.t("NamespaceDrugsEditor:Received by site fridge"),
    available: i18n.t("NamespaceDrugsEditor:Available"),
    assigned_to_a_patient: i18n.t("NamespaceDrugsEditor:Assigned to a patient"),
    allocated: i18n.t("NamespaceDrugsEditor:Allocated"),
    quarantined_by_fridge: i18n.t("NamespaceDrugsEditor:Quarantined - at the fridge"),
    validated_by_the_research_coordinator:
      i18n.t("NamespaceDrugsEditor:Validated by the research coordinator"),
    in_transit_manufacturer_pharmacy: i18n.t("NamespaceDrugsEditor:In transit manufacturer pharmacy"),
    sent_back_to_manufacturer: i18n.t("NamespaceDrugsEditor:Sent back to manufacturer"),
    sent_back_to_depot: i18n.t("NamespaceDrugsEditor:Sent back to depot"),
    no_longer_available_offline: i18n.t("NamespaceDrugsEditor:No longer available / damaged"),
    lost: i18n.t("NamespaceDrugsEditor:Lost"),
    quarantined_by_manufacturer: i18n.t("NamespaceDrugsEditor:Quarantined - at manufacturer"),
    quarantined_by_depot: i18n.t("NamespaceDrugsEditor:Quarantined - at drug depot"),
    reviewed_by_manufacturer: i18n.t("NamespaceDrugsEditor:Reviewed - at the manufacturer"), // Reviewed -
    reviewed_by_depot: i18n.t("NamespaceDrugsEditor:Reviewed - at drug depot"), // Reviewed -
    reviewed_by_fridge: i18n.t("NamespaceDrugsEditor:Reviewed - at the fridge"), // Reviewed -
    returned_destroyed: i18n.t("NamespaceDrugsEditor:Returned / Destroyed"),
    sent_back_to_pharmacy: i18n.t("NamespaceDrugsEditor:Sent back to Pharmacy"),
    replaced: i18n.t("NamespaceDrugsEditor:Replaced / Reallocated"),
    grouped_by_quarantined: i18n.t("NamespaceDrugsEditor:Quarantined - Manually"),
    grouped_by_reviewed: i18n.t("NamespaceDrugsEditor:Reviewed"),
    dispensed_to_the_depot: i18n.t("NamespaceDrugsEditor:Transferred to the depot"),
    courier_sent_to_the_patient: i18n.t("NamespaceDrugsEditor:Courier sent to the patient"),
    received_by_patient: i18n.t("NamespaceDrugsEditor:Delivered to patient"),
    returned_by_patient: i18n.t("NamespaceDrugsEditor:Returned by patient"),
    sent_back_to_central_pharmacy: i18n.t("NamespaceDrugsEditor:Sent back to central pharmacy"),
    sent_back_to_fridge: i18n.t("NamespaceDrugsEditor:Sent back to the fridge"),
    expired: i18n.t("NamespaceDrugsEditor:Expired"),
  };
};



// WEBPACK FOOTER //
// ./src/data/mappedStatus.js